// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/event-price-summary-schema',
  type: 'object',
  required: [],
  nullable: true,
  properties: {
    eventPartyRoleId: {
      type: 'string',
      format: 'uuid',
    },
    orderTemplateId: {
      type: 'string',
      format: 'uuid',
    },
    customerGroupTotalPrices: {
      type: 'number',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
